import SlotServices from "./SlotServices";

export * from "./SlotServices";
export default SlotServices;
